import { heroEquipment } from "../HeroEquipment";

export const averland = {
  heroes: {
    Kapitan: {
      id: 0,
      startingEquipment: ["Sztylet", "Miecz"],
      cost: 55,
      number: 1,
      equipmentList: heroEquipment["Strażnicy dróg z Averlandu"].Bohaterowie,
      type: "Bohater",
      stats: {
        Początkowa: [4, 4, 4, 3, 3, 2, 4, 1, 8],
        Maksymalna: [5, 6, 6, 4, 4, 3, 6, 4, 9],
      },
      rules: ["Dowódca"],
      exp: 20,
      skills: [0, 1, 2, 3, 4, 5],
    },
    "Magister Magii": {
      id: 1,
      startingEquipment: ["Sztylet", "Kostur"],
      cost: 35,
      number: 1,
      equipmentList: {
        "Tradycja Bestii": [0, 4, "Tradycja"],
        "Tradycja Cienia": [0, 4, "Tradycja"],
        "Tradycja Metalu": [0, 4, "Tradycja"],
        "Tradycja Niebios": [0, 4, "Tradycja"],
        "Tradycja Ognia": [0, 4, "Tradycja"],
        "Tradycja Śmierci": [0, 4, "Tradycja"],
        "Tradycja Światła": [0, 4, "Tradycja"],
        "Tradycja Życia": [0, 4, "Tradycja"],
      },
      type: "Bohater",
      stats: {
        Początkowa: [4, 3, 3, 3, 3, 1, 3, 1, 8],
        Maksymalna: [5, 6, 6, 4, 4, 3, 6, 4, 9],
      },
      rules: ["Mag (Kolegia Magii)"],
      exp: 12,
      skills: [],
    },
    "Prezbiter Sigmara": {
      id: 2,
      startingEquipment: ["Sztylet", "Buława/Maczuga/Młot bojowy"],
      cost: 35,
      number: 1,
      equipmentList: heroEquipment["Strażnicy dróg z Averlandu"].Prezbiter,
      type: "Bohater",
      stats: {
        Początkowa: [4, 3, 3, 3, 3, 1, 3, 1, 8],
        Maksymalna: [5, 6, 6, 4, 4, 3, 6, 4, 9],
      },
      rules: [
        "Czarostwo",
        "Duchowny (modlitwy do Sigmara)",
        "Modlitwa",
        "Nienawiść",
        "Przepastne trzewia",
        "Rozproszenie magii (2)",
      ],
      exp: 12,
      skills: [0, 2, 3, 5],
    },
    Sierżant: {
      id: 3,
      startingEquipment: ["Sztylet", "Miecz"],
      cost: 25,
      number: 1,
      equipmentList: heroEquipment["Strażnicy dróg z Averlandu"].Bohaterowie,
      type: "Bohater",
      stats: {
        Początkowa: [4, 4, 3, 3, 3, 1, 3, 1, 7],
        Maksymalna: [5, 6, 6, 4, 4, 3, 6, 4, 9],
      },
      rules: ["Podoficer"],
      exp: 8,
      skills: [0, 3, 4, 5],
    },
    Traper: {
      id: 4,
      startingEquipment: ["Sztylet", "Kusza"],
      cost: 25,
      number: 2,
      equipmentList: heroEquipment["Strażnicy dróg z Averlandu"].Bohaterowie,
      type: "Bohater",
      stats: {
        Początkowa: [4, 3, 4, 3, 3, 1, 3, 1, 7],
        Maksymalna: [5, 6, 6, 4, 4, 3, 6, 4, 9],
      },
      rules: ["Pułapkarz", "Ranger", "Zwiadowca"],
      exp: 8,
      skills: [0, 1, 4, 5],
    },
    "Strażnik dróg": {
      id: 5,
      startingEquipment: ["Sztylet"],
      cost: 20,
      number: 15,
      equipmentList: heroEquipment["Strażnicy dróg z Averlandu"].Stronnicy,
      type: "Stronnik",
      stats: {
        Początkowa: [4, 3, 3, 3, 3, 1, 3, 1, 7],
        Maksymalna: [5, 6, 6, 4, 4, 3, 6, 4, 9],
      },
      rules: ["Chorążowie & sygnaliści", "Drużyna obsługi", "Drużyna wsparcia"],
    },
    Myśliwy: {
      id: 6,
      startingEquipment: ["Sztylet", "Łuk"],
      cost: 20,
      number: 7,
      equipmentList: heroEquipment["Strażnicy dróg z Averlandu"].Stronnicy,
      type: "Stronnik",
      stats: {
        Początkowa: [4, 3, 3, 3, 3, 1, 3, 1, 7],
        Maksymalna: [5, 6, 6, 4, 4, 3, 6, 4, 9],
      },
      rules: ["Ranger", "Zwiadowca"],
    },
    Pikinier: {
      id: 7,
      startingEquipment: ["Sztylet", "Włócznia"],
      cost: 30,
      number: 5,
      equipmentList: heroEquipment["Strażnicy dróg z Averlandu"].Stronnicy,
      type: "Stronnik",
      stats: {
        Początkowa: [4, 4, 3, 3, 3, 1, 3, 1, 7],
        Maksymalna: [5, 6, 6, 4, 4, 3, 6, 4, 9],
      },
      rules: ["Szermierz"],
    },
    Rajtar: {
      id: 8,
      startingEquipment: [
        "Sztylet",
        "Miecz",
        "Pistolet",
        "Koń bojowy",
        "Siodło & uprząż",
      ],
      cost: 70,
      number: 3,
      equipmentList: heroEquipment["Strażnicy dróg z Averlandu"].Rajtar,
      type: "Stronnik",
      stats: {
        Początkowa: [4, 3, 3, 3, 3, 1, 3, 1, 7],
        Maksymalna: [5, 6, 6, 4, 4, 3, 6, 4, 9],
        "Koń bojowy": [8, 3, 0, 3, "-", "-", 3, 1, 5],
      },
      rules: ["Kawalerzysta", "Lekka jazda", "Rajtar"],
    },
    "Pogromca trolli": {
      id: 9,
      startingEquipment: [
        "Topór krasnoludów",
        "Topór krasnoludów",
        "Broń wielka",
      ],
      cost: 50,
      number: 3,
      equipmentList: heroEquipment["Strażnicy dróg z Averlandu"].Pogromca,
      type: "Stronnik",
      stats: {
        Początkowa: [3, 4, 3, 3, 4, 1, 2, 1, 10],
        Maksymalna: [4, 7, 6, 4, 5, 3, 5, 4, 10],
      },
      rules: ["Fanatyk","Krzepki","Nieustępliwy","Ochronne tatuaże","Odporność na magię (2)","Pogromca","Rankor","Topory pogromcy","Trudny do zabicia","Uporczywość","Wspinaczka","Zabobonny lęk"],
    },
    Zaprzęg: {
      id: 10,
      startingEquipment: [],
      cost: 175,
      number: 1,
      equipmentList: {},
      type: "Machina",
      stats: {
        Powóz: ["-", "-", "-", 4, 8, 8, "-", "-", "-"],
        Koń: [8, 3, 0, 3, "-", "-", 3, 1, 5],
        "Koń ": [8, 3, 0, 3, "-", "-", 3, 1, 5],
      },
      rules: ["Duży cel", "Kontakty handlowe (3)", "Machina wojenna", "Powóz"],
    },
    Rydwan: {
      id: 11,
      startingEquipment: [],
      cost: 125,
      number: 1,
      equipmentList: {},
      type: "Machina",
      stats: {
        Rydwan: ["-", "-", "-", 5, 5, 8, "-", "-", "-"],
        Koń: [8, 3, 0, 3, "-", "-", 3, 1, 5],
        "Koń ": [8, 3, 0, 3, "-", "-", 3, 1, 5],
      },
      rules: ["Duży cel", "Machina wojenna", "Rydwan"],
    },
  },
  limit: 500,
  minModels: 3,
  maxModels: 15,
  name: "Strażnicy dróg z Averlandu",
  nature: "Neutralna",
  armyRules: [],
  mercenaries: [
    "Balistyk",
    "Bombardier",
    "Gladiator",
    "Goniec",
    "Kartograf",
    "Kupiec",
    "Latarnik",
    "Łowca czarownic",
    "Łowca nagród",
    "Magus",
    "Medyk",
    "Minstrel",
    "Miotacz ołowiu",
    "Ochroniarz",
    "Ordynans",
    "Poszukiwacz złota",
    "Rycerz najemny",
    "Skryba",
    "Strażnik dróg",
    "Szczurołap",
    "Szpieg",
    "Tileański kusznik",
    "Trefniś",
    "Woźnica",
    "Wróżbita",
    "Zwadźca",
    "Zwiadowca",
  ],
};
